import React from "react";

function HomeSlider() {
  return (
    <div
      id="homeCarousel"
      className="carousel slide"
      data-bs-ride="carousel"
      data-bs-interval="3000"
    >
      {/* Indicators */}
      <div className="carousel-indicators">
        <button
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide-to="0"
          className="active"
        >
        </button>
        <button
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide-to="1"
        >
        </button>
        <button
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide-to="2"
        >
        </button>
        <button
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide-to="3"
        >
        </button>
        <button
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide-to="4"
        >
        </button>
        <button
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide-to="5"
        >
        </button>
        <button
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide-to="6"
        >
        </button>
        <button
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide-to="7"
        >
        </button>
      </div>
      {/* Slides */}
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/slider3.jpg"
            className="d-block w-100"
            alt="Slide 1"
          />
          <div className="slider-overlay"></div>
          <div className="carousel-caption-custom">
            <h1>
              Educating <span className="leader-text">Leaders</span>
              Since 1971
            </h1>
            <p>Where Courage Becomes Destiny</p>

            <div className="slider-btns">
              <a href="/about-us" className="slider-btn explore-btn">
                Explore Campus
              </a>

              <a href="#" className="slider-btn admission-btn">
                Admissions
              </a>
            </div>
          </div>

        </div>
        <div className="carousel-item">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/slider4.jpg"
            className="d-block w-100"
            alt="Slide 2"
          />
          {/* <div className="slider-overlay"></div>
          <div className="carousel-caption-custom">
            <h1>
              Educating <span className="leader-text">Leaders</span>
              Since 1967
            </h1>
            <p>Where Courage Becomes Destiny</p>

            <div className="slider-btns">
              <a href="#" className="slider-btn explore-btn">
                Explore Campus
              </a>

              <a href="#" className="slider-btn admission-btn">
                Admissions
              </a>
            </div>
          </div> */}
        </div>
        <div className="carousel-item">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/slider5.jpeg"
            className="d-block w-100"
            alt="Slide 3"
          />
        </div>
        <div className="carousel-item">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/slider6.jpeg"
            className="d-block w-100"
            alt="Slide 4"
          />
        </div>
        <div className="carousel-item">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/slider7.jpeg"
            className="d-block w-100"
            alt="Slide 5"
          />
        </div>
        <div className="carousel-item">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/slider8.jpeg"
            className="d-block w-100"
            alt="Slide 3"
          />
        </div>
        <div className="carousel-item">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/slider9.jpeg"
            className="d-block w-100"
            alt="Slide 6"
          />
        </div>
        <div className="carousel-item">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/slider10.jpeg"
            className="d-block w-100"
            alt="Slide 7"
          />
        </div>
      </div>
      {/* Prev */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#homeCarousel"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon"></span>
      </button>
      {/* Next */}
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#homeCarousel"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon"></span>
      </button>
    </div>
  );
}

export default HomeSlider;